module.exports = __webpack_public_path__ + "static/media/leana-baechtold-2.05aa1a26.jpg";